import { useQuery } from '@tanstack/react-query';
import { API, graphqlOperation } from 'aws-amplify';

const listKPIRulesByOrgQuery = `
  query ListKPIRulesByOrg(
    $orgID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelKPIRuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listKPIRulesByOrg(
      orgID: $orgID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        contactDispositionFilter
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
      }
      nextToken
    }
  }
`;

const fetchKPIs = async (orgID: string) => {
  const kpis: any[] = [];
  let nextToken: string | null = null;

  do {
    const res: any = await API.graphql(
      graphqlOperation(listKPIRulesByOrgQuery, {
        orgID,
        filter: { isDeleted: { eq: false } },
        limit: 10000,
        nextToken,
      })
    );
    kpis.push(...res.data.listKPIRulesByOrg.items);
    nextToken = res.data.listKPIRulesByOrg.nextToken;
  } while (nextToken);

  // Add name alias and sort by sourceType
  kpis.forEach((el) => (el.name = el.title));
  kpis.sort((a, b) =>
    (a.sourceType || '')
      .toLowerCase()
      .localeCompare((b.sourceType || '').toLowerCase())
  );

  return kpis;
};

export default function useListKPIs() {
  const orgID = (global as any).me?.orgID;
  console.log('ORGID@!! ', orgID);

  const { data, isLoading, error } = useQuery({
    queryKey: ['listKPIs', orgID],
    queryFn: () => fetchKPIs(orgID),
    enabled: !!orgID,
    staleTime: 60 * 60 * 1000, // 1 hour
    gcTime: 2 * 60 * 60 * 1000, // 2 hours
    refetchOnWindowFocus: false,
  });
  console.log('DATATAATATA ', data);
  console.log('ERRRORR ', error);

  return { data: data ?? [], isLoading, error };
}
